export default {
  id: 192,
  title: 'Target #192 - Abstract Firefly',
  url: 'https://cssbattle.dev/play/192',
  colors: ['#1D471D', '#CCE58E'],
  solution:
    '<p a><p b><p c><p d><p e><style>p[a],p[b]{top:59;left:60}p[d],p[e]{top:111;border-width:36 25 0}p[c],p[d],p[e]{border-width:36 25 0}p[b],p[c],p[d],p[e]{border-style:solid;border-color:#1d471d transparent}body{background:#1d471d;margin:0}p{position:fixed}p[a]{border-style:solid;border-width:150 140 0;border-color:#cce58e #1d471d}p[b]{border-width:20 139 0}p[c]{top:73;left:175}p[d]{left:235;rotate:135deg}p[e]{right:235;rotate:-135deg',
}
